import { Component } from 'react'
import { Box, ProductInfoBox, Spacer, Button, ProductInfoBoxOrder, EncodingCountersBox } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { TmrProduct, EncodingCounters, ProductInfoField, ProductionOrder } from 'stylewhere/api'
import { DEFAULT_PRODUCT_ATTRIBUTES, showCountersOnEncoding } from 'stylewhere/shared/utils'

export interface EncodingProductProps {
  product?: TmrProduct
  clear: any
  counters?: EncodingCounters
  fields?: ProductInfoField[]
  productClose?: any
  initialType?: string
  operationId?: string
  code?: string
  disabledClear?: boolean
  flex?: boolean
  productionOrder?: ProductionOrder
  productionOrderDetail?: () => void
  order?: any
}

interface State {
  viewProductAttribute: boolean
}

export class EncodingProduct extends Component<EncodingProductProps, State> {
  state: State = {
    viewProductAttribute: false
  }

  getProductFields = () => {
    const { fields } = this.props
    const { viewProductAttribute } = this.state
    if (viewProductAttribute) {
      return fields
    }
    return fields.slice(0, DEFAULT_PRODUCT_ATTRIBUTES)
  }

  managerViewProductAttribute = () => {
    this.setState({ viewProductAttribute: !this.state.viewProductAttribute })
  }

  render() {
    const {
      productionOrder,
      product,
      clear,
      counters,
      fields,
      productClose,
      initialType,
      operationId,
      code,
      disabledClear,
      flex,
      productionOrderDetail,
      order
    } = this.props
    return (
      <Box flex={flex !== undefined ? (flex ? 1 : 0) : true} justify={'space-between'}>
        <Box mb={10}>
          <ProductInfoBoxOrder initialType={initialType} code={code} operationId={operationId} order={order} />
          <ProductInfoBox
            product={product}
            onCloseClick={productClose}
            paddingCard={'20px 20px 20px 20px'}
            fields={this.getProductFields()}
            showMore={fields.length > DEFAULT_PRODUCT_ATTRIBUTES ? () => this.managerViewProductAttribute() : undefined}
            viewMore={this.state.viewProductAttribute}
          />
          {counters && showCountersOnEncoding(initialType, counters) && (
            <>
              <Spacer height={'10'} />
              <EncodingCountersBox
                counters={counters}
                productionOrder={productionOrder}
                productionOrderDetail={productionOrderDetail}
              />
              <Spacer height={'10'} />
            </>
          )}
        </Box>
        {!disabledClear && <Button variant="default" title={__(T.misc.clear)} onClick={clear} />}
      </Box>
    )
  }
}
